var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M8.00003 12.5715L2.85718 7.42859L4.57145 5.71432L6.85715 8.00002L6.85715 -5.49511e-07L9.14285 -3.49689e-07L9.14285 8.00002L11.4285 5.71432L13.1428 7.42859L8.00003 12.5715Z"}}),_c('path',{attrs:{"d":"M16 13.7148L-1.90735e-06 13.7148L-2.10717e-06 16.0005L16 16.0005L16 13.7148Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }